// Personal Development Domain - Learning, skills, and personal growth conversations
export const personalDevelopmentData = {
  hub: {
    id: "hub_personal_development",
    label: "Personal Development",
    content: "Learning, skills, and personal growth conversations including career advancement and technology learning",
    visibility: "public",
    timestamp: 1703980800000,
    category: "Domain Hub",
    level: 0,
    nodeType: "hub"
  },

  clusters: [
    {
      id: "cluster_career_growth",
      label: "Career Advancement",
      content: "Professional development, interviews, skill building, and career planning strategies",
      visibility: "private",
      timestamp: 1703937600000,
      category: "Project Cluster",
      level: 1,
      parentHub: "hub_personal_development",
      nodeType: "cluster"
    },
    {
      id: "cluster_tech_learning",
      label: "Technology Learning",
      content: "Learning new frameworks, languages, and development practices to stay current in tech",
      visibility: "public",
      timestamp: 1703894400000,
      category: "Project Cluster",
      level: 1,
      parentHub: "hub_personal_development",
      nodeType: "cluster"
    }
  ],

  areas: [
    {
      id: "area_interview_prep",
      label: "Technical Interviews",
      content: "Algorithm practice, system design, and interview strategies for senior developer positions",
      visibility: "private",
      timestamp: 1703932800000,
      category: "Topic Area",
      level: 2,
      parentCluster: "cluster_career_growth",
      parentHub: "hub_personal_development",
      nodeType: "area"
    },
    {
      id: "area_leadership_skills",
      label: "Engineering Leadership",
      content: "Team management, technical leadership, and communication skills for senior roles",
      visibility: "private",
      timestamp: 1703928400000,
      category: "Topic Area",
      level: 2,
      parentCluster: "cluster_career_growth",
      parentHub: "hub_personal_development",
      nodeType: "area"
    },
    {
      id: "area_react_advanced",
      label: "Advanced React",
      content: "Hooks, context, performance optimization, testing, and modern React patterns",
      visibility: "public",
      timestamp: 1703889600000,
      category: "Topic Area",
      level: 2,
      parentCluster: "cluster_tech_learning",
      parentHub: "hub_personal_development",
      nodeType: "area"
    },
    {
      id: "area_system_design",
      label: "System Design Learning",
      content: "Distributed systems, scalability patterns, and architecture design principles",
      visibility: "public",
      timestamp: 1703885200000,
      category: "Topic Area",
      level: 2,
      parentCluster: "cluster_tech_learning",
      parentHub: "hub_personal_development",
      nodeType: "area"
    }
  ],

  mementos: [
    {
      id: "memento_009",
      label: "System Design Interview: Chat application architecture",
      content: "Me: 'I have a system design interview tomorrow. Can you help me practice designing a chat application like WhatsApp?' \n\nPracticed designing for 100M users, 1B messages/day. Covered: WebSocket connections for real-time messaging, message delivery guarantees, database sharding by user_id. Key components: API Gateway, Message Service, Notification Service, Media Storage (S3), Redis for online users. Discussed CAP theorem trade-offs and eventual consistency for message ordering.",
      visibility: "private",
      timestamp: 1703928000000,
      category: "Interview Practice",
      level: 3,
      parentArea: "area_interview_prep",
      parentCluster: "cluster_career_growth",
      parentHub: "hub_personal_development",
      subcategory: "System Design",
      nodeType: "memento"
    },
    {
      id: "memento_010",
      label: "Algorithm Practice: Dynamic programming breakthrough",
      content: "Me: 'I keep struggling with DP problems in interviews. Can you help me understand the patterns better?' \n\nWorked through classic problems: longest increasing subsequence, edit distance, knapsack variations. KEY INSIGHT: identify optimal substructure and overlapping subproblems first. Learned memoization vs tabulation trade-offs. Practice results: went from 3/10 to 15/20 medium problems solved correctly. Pattern recognition is everything!",
      visibility: "private",
      timestamp: 1703924400000,
      category: "Algorithm Practice",
      level: 3,
      parentArea: "area_interview_prep",
      parentCluster: "cluster_career_growth",
      parentHub: "hub_personal_development",
      subcategory: "Data Structures",
      nodeType: "memento"
    },
    {
      id: "memento_011",
      label: "Team Leadership: Managing difficult conversations",
      content: "Me: 'One of my junior developers is consistently missing deadlines and I need to address it. How do I approach this conversation?' \n\nDiscussed feedback frameworks: SBI (Situation-Behavior-Impact), focusing on specific examples rather than personality. Learned about psychological safety and growth mindset. Key: address performance while maintaining relationship. Follow-up plan with clear expectations and support. The conversation went well - dev appreciated the direct but supportive approach.",
      visibility: "private",
      timestamp: 1703920000000,
      category: "Leadership Development",
      level: 3,
      parentArea: "area_leadership_skills",
      parentCluster: "cluster_career_growth",
      parentHub: "hub_personal_development",
      subcategory: "Team Management",
      nodeType: "memento"
    },
    {
      id: "memento_012",
      label: "Technical Mentoring: Code review best practices",
      content: "Me: 'I want to get better at code reviews. How can I give constructive feedback that actually helps junior developers learn?' \n\nLearned the 'compliment sandwich' is outdated. Better approach: specific, actionable feedback focused on code quality, security, and learning opportunities. Use questions instead of commands ('What do you think about extracting this into a function?'). Always explain the 'why' behind suggestions. Resulted in much more positive team feedback.",
      visibility: "public",
      timestamp: 1703916000000,
      category: "Mentoring Skills",
      level: 3,
      parentArea: "area_leadership_skills",
      parentCluster: "cluster_career_growth",
      parentHub: "hub_personal_development",
      subcategory: "Code Reviews",
      nodeType: "memento"
    },
    {
      id: "memento_013",
      label: "React Hooks: Custom useApi hook with error handling",
      content: "Me: 'I'm tired of writing the same loading/error/data logic for every API call. Can you help me build a reusable hook?' \n\nBuilt comprehensive useApi hook with loading states, error handling, retry logic, and race condition protection. Handles cleanup with AbortController. Usage: const {data, loading, error, retry} = useApi('/api/users'). Reduced API-related code duplication by 70% across the app. Team loves it!",
      visibility: "public",
      timestamp: 1703884800000,
      category: "Code Development",
      level: 3,
      parentArea: "area_react_advanced",
      parentCluster: "cluster_tech_learning",
      parentHub: "hub_personal_development",
      subcategory: "Custom Hooks",
      nodeType: "memento"
    },
    {
      id: "memento_014",
      label: "React Testing: Testing Library mental model shift",
      content: "Me: 'I keep writing tests that break when I refactor components. What am I doing wrong with React Testing Library?' \n\nLearned to test USER BEHAVIOR, not implementation details. Use screen.getByRole() over getByTestId(). Test what users actually see and do. Stopped testing internal state and focused on component outputs. Also learned accessibility testing with screen readers. Now my tests are more resilient and actually catch user-facing bugs.",
      visibility: "public",
      timestamp: 1703880000000,
      category: "Testing Strategy",
      level: 3,
      parentArea: "area_react_advanced",
      parentCluster: "cluster_tech_learning",
      parentHub: "hub_personal_development",
      subcategory: "Unit Testing",
      nodeType: "memento"
    },
    {
      id: "memento_015",
      label: "Microservices: When to split vs keep monolithic",
      content: "Me: 'Everyone talks about microservices but our monolith works fine. How do I know when to split services?' \n\nKey insight: split on TEAM boundaries, not technical ones. Conway's Law applies. Microservices add complexity - only worth it when you have: multiple teams, different scaling needs, or independent deployment requirements. For most startups: start monolithic, extract services when team structure demands it. Premature microservices are expensive.",
      visibility: "public",
      timestamp: 1703876400000,
      category: "Architecture Learning",
      level: 3,
      parentArea: "area_system_design",
      parentCluster: "cluster_tech_learning",
      parentHub: "hub_personal_development",
      subcategory: "Distributed Systems",
      nodeType: "memento"
    },
    {
      id: "memento_016",
      label: "Database Scaling: Sharding vs read replicas strategy",
      content: "Me: 'Our PostgreSQL database is hitting limits. Should we shard or add read replicas? What are the trade-offs?' \n\nLearned scaling progression: vertical scaling -> read replicas -> connection pooling -> caching -> sharding (last resort). Read replicas solve 80% of problems with 20% of complexity. Sharding is complex (cross-shard queries, rebalancing) but necessary for write-heavy workloads. Started with read replicas + Redis cache - solved our immediate issues.",
      visibility: "public",
      timestamp: 1703872000000,
      category: "Database Learning",
      level: 3,
      parentArea: "area_system_design",
      parentCluster: "cluster_tech_learning",
      parentHub: "hub_personal_development",
      subcategory: "Database Architecture",
      nodeType: "memento"
    }
  ]
};
